var map = {
	"./bmr-demon.png": "cae1",
	"./bmr-minion.png": "28bf",
	"./bmr-outsider.png": "e898",
	"./bmr-townsfolk.png": "e988",
	"./bmr.png": "7496",
	"./custom.png": "441d",
	"./luf.png": "92d8",
	"./snv-demon.png": "f347",
	"./snv-minion.png": "451a",
	"./snv-outsider.png": "4dd9",
	"./snv-townsfolk.png": "ed00",
	"./snv.png": "2fd0",
	"./tb-demon.png": "a3b0",
	"./tb-minion.png": "5f4e",
	"./tb-outsider.png": "73a1",
	"./tb-townsfolk.png": "f7a3",
	"./tb.png": "0aaa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ce23";